<template>
  <div class="fw-details">
    <div class="fw-details-inner">
      <h2>Froot Wheel Details</h2>

      <table class="fw-table fw-lookup">
        <tr>
          <td class="label-cell">FrootWheel Number</td>
          <td class="field-cell">
            <input
                type="text"
                id="froot-wheel-number"
                :value="frootwheel_number"
                @input="frootwheel_number = $event.target.value"
            >
          </td>
          <td class="btn-cell">
            <button type="button" class="fw-btn" @click="get_frootwheel_number()">Show Number</button>
          </td>
        </tr>
      </table>

      <table class="fw-table" v-if="frootwheel_number_data.ref_number">
        <tbody>
        <tr v-if="frootwheel_number_data.ref_number">
          <td class="label-cell">FrootWheel Number</td>
          <td>{{frootwheel_number_data.ref_number}}</td>
        </tr>
        <tr v-if="frootwheel_number_data.win_dollar">
          <td class="label-cell">Win Dollar</td>
          <td>${{frootwheel_number_data.win_dollar}}</td>
        </tr>

        <template v-if="frootwheel_number_data.status < 100">
          <tr>
            <td class="label-cell">Status</td>
            <td>Not scanned yet</td>
            </td>
          </tr>
          <tr>
            <td class="label-cell">Shop Name</td>
            <td>
              <input
                  type="text"
                  id="shop_name"
                  :value="frootwheel_number_data.shop_name"
                  @input="frootwheel_number_data.shop_name = $event.target.value"
                  @blur="set_frootwheel_field(frootwheel_number_data.ref_number,'shop_name',frootwheel_number_data.shop_name)">
            </td>
          </tr>
        </template>

        <template v-if="frootwheel_number_data.status === 200">
          <tr>
            <td class="label-cell">Winner Name</td>
            <td>{{frootwheel_number_data.name}}</td>
          </tr>
          <tr>
            <td class="label-cell">Winner Phone</td>
            <td>{{frootwheel_number_data.phone}}</td>
          </tr>
          <tr>
            <td class="label-cell">Winning Date</td>
            <td>{{frootwheel_number_data.finishdate}}</td>
          </tr>
          <tr>
            <td class="label-cell">Shop Name</td>
            <td>
              <input
                  type="text"
                  id="shop_name_2"
                  :value="frootwheel_number_data.shop_name"
                  @input="frootwheel_number_data.shop_name = $event.target.value"
                  @blur="set_frootwheel_field(frootwheel_number_data.ref_number,'shop_name',frootwheel_number_data.shop_name)">
            </td>
          </tr>
          <tr>
            <td class="label-cell">Payment Type</td>
            <td>
              <input
                  type="text"
                  id="payment_method"
                  :value="frootwheel_number_data.payment_method"
                  @input="frootwheel_number_data.payment_method = $event.target.value"
                  @blur="set_frootwheel_field(frootwheel_number_data.ref_number,'payment_method',frootwheel_number_data.payment_method)">
            </td>
          </tr>
          <tr>
            <td class="label-cell">Payment Date</td>
            <td v-if="frootwheel_number_data.payment_sent.length === 0" class="btn-cell">
              <button type="button" class="fw-btn" v-on:click="set_frootwheel_field(frootwheel_number_data.ref_number,'payment_sent','button')">Mark as paid</button>
            </td>
            <td v-else>
              {{frootwheel_number_data.payment_sent}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>

      <table class="fw-table fw-lookup" v-if="frootwheel_number_data.status < 100">
        <tr>
          <td class="label-cell">Set New Dollar Value $</td>
          <td class="field-cell">
            <input
                type="text"
                id="froot-wheel-new-dollar"
                :value="new_dollar"
                @input="new_dollar = $event.target.value"
            >
          </td>
          <td class="btn-cell">
            <button type="button" class="fw-btn" @click="get_frootwheel_number_add_new()">Set New $</button>
          </td>
        </tr>
      </table>

      <table class="fw-table" v-if="frootwheel_number_data.ref_number > 0">
        <tbody>
        <tr>
          <td class="label-cell">Notes</td>
          <td>
            <input
                type="text"
                id="notes"
                class="notes-input"
                :value="frootwheel_number_data.notes"
                @input="frootwheel_number_data.notes = $event.target.value"
                @blur="set_frootwheel_field(frootwheel_number_data.ref_number,'notes',frootwheel_number_data.notes)">
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      frootwheel_number: '',
      new_dollar: 0,
    }
  },
  computed: {
    ...mapGetters({
      frootwheel_number_data: 'admin/frootwheel_number_data',
    }),
  },
  mounted() {
    this.new_dollar = this.frootwheel_number_data.win_dollar;
  },
  watch: {
    frootwheel_number_data: async function() {
      this.new_dollar     = this.frootwheel_number_data.win_dollar;
    },
  },
  methods: {
    set_frootwheel_field (id,fieldname,value) {
      let origin = 2;
      this.$store.dispatch('admin/setFrootWheelField', {id,fieldname,value,origin})
    },
    get_frootwheel_number_add_new () {
      this.$store.dispatch('admin/frootWheelNumber', {'frootwheel_number': this.frootwheel_number_data.ref_number, new_dollar: this.new_dollar});
      this.frootwheel_number = '';
    },
    get_frootwheel_number () {
      this.$store.dispatch('admin/frootWheelNumber', {'frootwheel_number': this.frootwheel_number, new_dollar: 0});
      this.frootwheel_number = '';
    },
  }
}
</script>

<style scoped>
.fw-details {
  padding: 10px;
  box-sizing: border-box;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #1a3038;
  background: #fff;
}
.fw-details-inner {
  width: 50%;
  max-width: 680px;
  margin: 0 auto;
}
.fw-details h2 {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 700;
}
.fw-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  line-height: 1.2;
  background: #fff;
  border: 1px solid #d7e0e4;
  margin: 0 0 14px;
}
.fw-table th,
.fw-table td {
  padding: 7px 8px;
  border: 1px solid #d7e0e4;
  vertical-align: middle;
  text-align: left;
}
.fw-table tbody tr:nth-child(even) {
  background: #fafcfd;
}
.label-cell {
  font-weight: 700;
  white-space: nowrap;
  background: #f4f7f8;
  color: #5d727a;
  width: 1%;
}
.field-cell,
.btn-cell {
  width: 1%;
  white-space: nowrap;
}
.fw-table input[type="text"] {
  display: block;
  box-sizing: border-box;
  width: 160px;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  background: #fff;
  font: inherit;
  font-size: 16px;
  color: #1a3038;
}
.fw-table input.notes-input {
  width: 100%;
  min-width: 0;
  max-width: none;
}
.fw-table input[type="text"]:focus {
  outline: none;
  border-color: #7eb7c6;
}
.fw-btn {
  display: inline-block;
  box-sizing: border-box;
  width: auto;
  height: 30px;
  line-height: 28px;
  padding: 0 10px;
  border: 1px solid #16343d;
  border-radius: 6px;
  background: #16343d;
  color: #fff;
  font: inherit;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.fw-btn:hover {
  background: #0f262c;
}
</style>
